import {UserService} from './../../../shared/services/user.service';
import {Customer} from './../../../shared/models/customer';
import {ArticleService} from './../../../shared/services/article.service';
import {ImageService} from '../../../shared/services/image.service';
import {Component, OnInit, OnDestroy} from '@angular/core';
import {CartItem} from '../../../shared/classes/cart-item';
import {ProductsService} from '../../../shared/services/products.service';
import {CartService, SecureCartItem} from '../../../shared/services/cart.service';
import {Observable, of, Subscription} from 'rxjs';
import {round} from '../../../shared/utils/utils';
import {Article} from '../../../shared/models/article';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
  providers: [ ImageService, ArticleService, UserService]
})
export class CartComponent implements OnInit, OnDestroy {

  public cartItems: Observable<CartItem[]> = of([]);
  public shoppingCartItems:   CartItem[] = [];
  public isLoading: boolean = true;
  private cartSubscription: Subscription;
 
  constructor(private productsService: ProductsService,
    private cartService: CartService, 
    private uploadFileService: ImageService,
    public articleService: ArticleService,
    private userService: UserService) { }

  ngOnInit() {
    // Subscribe to cart changes for real-time updates
    // This will fire immediately with the current value, so no need to call loadCartItems() separately
    this.cartSubscription = this.cartService.cartItems.subscribe((secureItems) => {
      // Reload cart when it changes
      this.loadCartItemsFromSecureItems(secureItems);
    });
  }

  ngOnDestroy() {
    if (this.cartSubscription) {
      this.cartSubscription.unsubscribe();
    }
  }

  private loadCartItemsFromSecureItems(secureItems: SecureCartItem[]) {
    this.isLoading = true;
    this.shoppingCartItems = [];

    if (secureItems && secureItems.length > 0) {
      // Extract SKUs from cart items
      const skus = secureItems.map(item => item.sku);

      // Load products from backend using SKUs
      this.articleService.getArticlesBySku(skus).subscribe(
        (products: Article[]) => {

          // Map products to cart items
          this.shoppingCartItems = secureItems
            .map(secureItem => {
              const product = products.find(p => p.sku === secureItem.sku);
              if (product) {
                return {
                  product: product,
                  quantity: secureItem.quantity
                } as CartItem;
              } else {
                console.error('❌ Producto NO encontrado para SKU:', secureItem.sku);
              }
              return null;
            })
            .filter(item => item !== null); // Remove items where product wasn't found

          this.isLoading = false;
        },
        error => {
          console.error('❌ Error loading cart products:', error);
          this.shoppingCartItems = [];
          this.isLoading = false;
        }
      );
    } else {
      // Empty cart
      this.shoppingCartItems = [];
      this.isLoading = false;
    }
  }

  public update(item: CartItem) {
      if (item.quantity <= 0) this.cartService.updateCartQuantity(item.product, 1);
  }

  // Increase Product Quantity
  public increment(product: any, quantity: number = 1) {
    this.cartService.updateCartQuantity(product, quantity);
  }
  
  // Decrease Product Quantity
  public decrement(product: any, quantity: number = -1) {
    this.cartService.updateCartQuantity(product, quantity);
  }
  
  // Get Total
  public getTotal(): Observable<number> {
    return this.cartService.getTotalAmount();
  }

  // Redondea valor
  roundValue = (value) => round(value);

  // Remove cart items
  public removeItem(item: CartItem) {
    this.cartService.removeFromCart(item);
  }

   getPriceProduct(item: CartItem) {   
    const c: Customer = this.userService.getIdentity();
    let price = item.product.unitPrice;
    if (c) {
      price = this.articleService.getPrice(item.product, c.listPrice);
    }
    return price;
  }

  getSubtotal(item: CartItem) {
    const price = this.getPriceProduct(item);
    return this.roundValue(price * item.quantity);
  }

  // arma url de la photo del articulo
	getUrl = (photos: string) => {        
		return this.uploadFileService.getUrlFirstElement(photos);
	}

	getPrice(p: Article) {
      const customer: Customer = this.userService.getIdentity();
      if (customer) {
        return this.articleService.getPrice(p, customer.listPrice);
      } else {
        return p.unitPrice;
      }
    }
}